<template>
  <h2 :class="$style.title">最近閲覧した作品</h2>
  <template v-if="isLoaded">
    <template v-if="items.length > 0">
      <ul :class="$style.list">
        <li v-for="item in items" :key="item.itemId">
          <a v-if="item.imagePath" :href="`/listing/item/${item.itemId}`"><img :src="dynamicImageUrl(item.imagePath, 190, 190)" :alt="item.title" width="67" height="67" loading="lazy" /></a>
          <div :class="$style.name">
            <a :href="`/listing/item/${item.itemId}`">{{ item.title }}</a>
          </div>
        </li>
      </ul>
      <p :class="$style.more"><a href="/listing/history">閲覧履歴</a></p>
    </template>
    <p v-else :class="$style.noItems">閲覧した作品はありません</p>
  </template>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { getHistoryItems, type Item } from '@/js/lib/api/item';

const isLoaded = ref(false);
const items = ref<Item[]>([]);

onMounted(async () => {
  items.value = await getHistoryItems({ limit: 36 });
  isLoaded.value = true;
});
</script>

<style module lang="scss">
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;

  @media (--sp) {
    margin-bottom: 10px;
  }
}

.list {
  display: flex;
  gap: 10px;
  overflow-x: auto;

  @media (--sp) {
    margin: 0 -10px;
    padding: 0 0 0 10px;
  }

  > li {
    min-width: calc(8.7% - 10px);
    padding-bottom: 12px;
    position: relative;
    width: calc(8.7% - 10px);

    @media (--sp) {
      min-width: calc(28.6% - 10px);
      width: calc(28.6% - 10px);
    }

    &:last-child::after {
      content: '';
      height: 1px;
      left: 100%;
      position: absolute;
      top: 0;
      width: 10px;
    }

    img {
      height: auto;
      width: 100%;
    }

    .name {
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.noItems {
  align-items: center;
  background-color: var(--color-gray100);
  display: flex;
  justify-content: center;
  min-height: 111.25px;

  @media (--sp) {
    min-height: calc(28.6vw + 23.14px); // 画像の高さが可変なので計算済みの値を設定
  }
}

.more {
  margin-top: 10px;
  text-align: right;

  a {
    padding-left: 12px;
    position: relative;

    &::before {
      content: $icon-arrow-right;
      font-family: $font-icon;
      font-size: 18px;
      left: -5px;
      line-height: 1;
      position: absolute;
      top: -2px;
    }
  }
}
</style>
